import React from 'react';
import PropTypes from 'prop-types';
import { LanguageChanger } from './LanguageChanger';

export const Banner = (props) => {
    return (
        <div className="homepageBanner">
            <button 
                className="title"
                onClick={props.handleTitleClick}
            >
                <span className="mCLASStitle">mCLASS&reg; </span>
                <span className="homeConnectTitle">Home Connect&reg;</span>    
            </button>
            <LanguageChanger
                handleClick={props.handleLanguageButtonClick}
                buttonText={props.languageButtonText} 
            />  
        </div>
    );
};

Banner.propTypes = {
    handleLanguageButtonClick: PropTypes.func.isRequired,
    languageButtonText: PropTypes.string.isRequired,
    handleTitleClick: PropTypes.func.isRequired,
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.jsx